import { render, staticRenderFns } from "./examineInfo.vue?vue&type=template&id=547d2916&scoped=true"
import script from "./examineInfo.vue?vue&type=script&lang=js"
export * from "./examineInfo.vue?vue&type=script&lang=js"
import style0 from "./examineInfo.vue?vue&type=style&index=0&id=547d2916&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d2916",
  null
  
)

export default component.exports